import { SITE_VARIABLES } from '../../../../../common/styles/variables';
import { flexRowBetween } from '../../../../../common/styles/flex';

interface StylesObject {
    moreVideosTitleStyle: { [key: string]: any };
    headerStyle: { [key: string]: any };
    closeIconStyle: { hide: { [key: string]: any } } & any;
}

const moreVideosTitle = {
  display: 'flex',
  margin: '4px 0px 0px 4px',
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  color: SITE_VARIABLES.COLORS.WHITE,
  endState: {
    position: 'absolute',
    bottom: '132px',
    margin: 'unset',
  },
};

const header = {
  ...flexRowBetween,
};

const closeIcon = {
  display: 'flex',
  alignItems: 'center',
  width: '12px',
  height: '12px',
  margin: '4px 4px 0px 0px',
  cursor: 'pointer',
  pointerEvents: 'auto',
};

export const getVideoHeaderStyleObject = (isEndState: boolean): StylesObject => ({
  moreVideosTitleStyle: [
    moreVideosTitle,
    isEndState && moreVideosTitle.endState,
  ],
  headerStyle: {
    ...header,
  },
  closeIconStyle: {
    ...closeIcon,
  },
});
